'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pluginsObjectExtend = require('plugins/object.extend');

var _pluginsObjectExtend2 = _interopRequireDefault(_pluginsObjectExtend);

/* Stores */

var _storesModuleInspector = require('stores/module-inspector');

var _storesModuleInspector2 = _interopRequireDefault(_storesModuleInspector);

/* Actions */

var _actionsModuleInspector = require('actions/module-inspector');

var _actionsModuleInspector2 = _interopRequireDefault(_actionsModuleInspector);

/* Components */

var _inspectorPropertyGroup = require('./inspector/property-group');

var _inspectorPropertyGroup2 = _interopRequireDefault(_inspectorPropertyGroup);

var _inspectorProperty = require('./inspector/property');

var _inspectorProperty2 = _interopRequireDefault(_inspectorProperty);

var _componentsUiButtonGroup = require('components/ui/button-group');

var _componentsUiButtonGroup2 = _interopRequireDefault(_componentsUiButtonGroup);

var _componentsUiButton = require('components/ui/button');

var _componentsUiButton2 = _interopRequireDefault(_componentsUiButton);

var _componentsUserInitials = require('components/user/initials');

var _componentsUserInitials2 = _interopRequireDefault(_componentsUserInitials);

var _componentsUiDate = require('components/ui/date');

var _componentsUiDate2 = _interopRequireDefault(_componentsUiDate);

var getType = function getType(obj) {
  return Object.prototype.toString.call(obj).match(/\s([a-z]+)\]$/i)[1].toLowerCase();
};

var clean = function clean(obj) {
  var type = getType(obj);

  if (type === 'array') {
    var newArray = obj.map(clean).filter(function (i) {
      return i !== null;
    });
    if (!newArray || !newArray.length) {
      return null;
    } else {
      return newArray;
    }
  }

  if (type === 'string') {
    if (obj === '') {
      return null;
    } else {
      return obj;
    }
  }

  if (type === 'undefined') {
    return null;
  }

  if (type === 'null') {
    return null;
  }

  if (type === 'object') {
    return obj;
  }

  var newObj = {};
  var added = false;
  for (var p in obj) {
    if (obj.hasOwnProperty(p)) {
      var val = clean(obj[p]);
      if (val !== null) {
        newObj[p] = val;
        added = true;
      }
    }
  }

  if (!added) {
    return null;
  }

  return newObj;
};

exports['default'] = _react2['default'].createClass({
  displayName: 'inspector',

  getInitialState: function getInitialState() {
    return {
      changes: {}
    };
  },

  render: function render() {
    var _this = this;

    var _props = this.props;
    var projectId = _props.projectId;
    var selectedModule = _props.selectedModule;
    var busy = _storesModuleInspector2['default'].busy;
    var saving = _storesModuleInspector2['default'].saving;
    var selectedPropertyGroupName = _storesModuleInspector2['default'].selectedPropertyGroupName;

    var moduleState = selectedModule.state;
    var propertyGroups = selectedModule.moduleType.propertyGroups;

    var propertyGroupNodes = propertyGroups.map(function (propertyGroup) {
      var propertyNodes = null;
      var propertyGroupState = moduleState[propertyGroup.name] || {};
      var propertyGroupSelected = propertyGroup.name === selectedPropertyGroupName;

      if (propertyGroupSelected) {
        propertyNodes = propertyGroup.properties.map(function (property) {
          var propertyValue = propertyGroupState[property.name];
          var dependencies = property.dependencies || [];

          var hidden = dependencies.some(function (dependency) {
            return dependency.hide && moduleState[dependency.group][dependency.property] !== dependency.value;
          });

          if (hidden) {
            return null;
          }

          return _react2['default'].createElement(_inspectorProperty2['default'], _extends({
            key: property.name
          }, property, {
            disabled: saving || busy,
            projectId: projectId,
            propertyGroupName: propertyGroup.name,
            value: propertyValue,
            onPerformAction: _this._onPerformAction,
            onChange: _this._onPropertyChange }));
        });
      }

      return _react2['default'].createElement(
        _inspectorPropertyGroup2['default'],
        _extends({
          key: propertyGroup.name
        }, propertyGroup, {
          selected: propertyGroupSelected,
          onClick: _this._onPropertyGroupClick }),
        propertyNodes
      );
    });

    var saveButtonNode = null;
    var hasChanges = false;
    var changes = this.state.changes;

    for (var groupName in changes) {
      if (!hasChanges && changes.hasOwnProperty(groupName)) {
        for (var propertyName in changes[groupName]) {
          if (changes[groupName].hasOwnProperty(propertyName)) {
            hasChanges = true;
            break;
          }
        }
      }
    }

    var saveButtonDisabled = !hasChanges || busy || saving;
    var saveButtonTranslationKey = saving ? 'saving' : hasChanges ? 'save' : 'no_changes_to_save';

    saveButtonNode = _react2['default'].createElement(_componentsUiButton2['default'], {
      translationKey: saveButtonTranslationKey,
      disabled: saveButtonDisabled,
      onClick: this._onSaveClick });

    var createdInfoNode = _react2['default'].createElement(
      'div',
      { className: 'creation-info' },
      'Created by ',
      _react2['default'].createElement(
        _componentsUserInitials2['default'],
        null,
        selectedModule.createdBy
      ),
      ' on ',
      _react2['default'].createElement(
        _componentsUiDate2['default'],
        null,
        new Date(selectedModule.createdAt)
      )
    );

    var description = _react2['default'].createElement(
      'div',
      { className: 'description' },
      selectedModule.moduleType.description
    );

    return _react2['default'].createElement(
      'div',
      { className: 'module-inspector-component' },
      _react2['default'].createElement(
        'div',
        { className: 'title' },
        selectedModule.moduleType.title
      ),
      createdInfoNode,
      description,
      _react2['default'].createElement(
        _componentsUiButtonGroup2['default'],
        null,
        saveButtonNode
      ),
      _react2['default'].createElement(
        'div',
        { className: 'list-component property-groups' },
        propertyGroupNodes
      )
    );
  },

  _onPropertyGroupClick: function _onPropertyGroupClick(propertyGroupName) {
    _actionsModuleInspector2['default'].modulePropertyGroupSelected(propertyGroupName);
  },

  _onPerformAction: function _onPerformAction(groupName, actionName) {
    var moduleId = this.props.selectedModule.id;
    var hasChanges = Object.keys(this.state.changes).length;

    // TODO: Move text to translations
    if (hasChanges && !confirm('Would you like to perform action without saving? Your changes will be ignored if you continue.')) {
      return;
    }
    _actionsModuleInspector2['default'].performModuleAction(moduleId, groupName, actionName);
  },

  /*
   * Each change comes in as a seperate call
   * The purpose of this method is to get the full picture
   */
  _onPropertyChange: function _onPropertyChange(groupName, propertyName, originalValue, value) {
    var changes = this.state.changes;
    var selectedModule = this.props.selectedModule;

    var moduleState = selectedModule.state;

    changes[groupName] = changes[groupName] || {};
    changes[groupName][propertyName] = originalValue === value ? null : value;

    var cleanChanges = clean(changes);

    (0, _pluginsObjectExtend2['default'])(moduleState, cleanChanges);

    /* Uncomment to see changes realtime in console */
    // console.log('Changes', cleanChanges, moduleState)

    this.setState({ changes: changes, moduleState: moduleState });
  },

  _onSaveClick: function _onSaveClick() {
    _actionsModuleInspector2['default'].saveModuleChanges(this.state.changes);
    this.setState({ changes: {} });
  }
});
module.exports = exports['default'];


/** WEBPACK FOOTER **
 ** ../~/babel-loader!./js/components/project/playground/module/inspector.js
 **/